// extracted by mini-css-extract-plugin
module.exports = {"cmp":"team_cmp__3Cdwp","off":"team_off__3Qd5G"};